enum StorageType {
  S3AwsBucket = 1,
  SFTP = 2,
  Azure = 3,
  GCP = 4,
}

enum StorageTypeName {
  S3AwsBucket = 'Amazon S3',
  SFTP = 'SFTP',
  Azure = 'Azure Blob Storage',
  GCP = 'Google Cloud Platform Storage',
}

interface S3AwsBucketCredentials {
  accessToken: string;
  secret: string;
}

interface SFTPCredentials {
  username: string;
  password: string;
  privateKey: string;
  privateKeyPassphrase: string;
}

interface AzureCredentials {
  accountName: string;
  accountKey: string;
}

interface GCPCredentials {
  jsonKey: string;
}

type StorageCredentials = (
  | S3AwsBucketCredentials
  | SFTPCredentials
  | AzureCredentials
  | GCPCredentials
) & {
  type: StorageType;
};

interface StorageRepositoryCredentials {
  credentials: StorageCredentials;
  secret: string;
  accessToken: string;
}

interface StorageRepository {
  name: string;
  type: StorageType;
  path: string;
  region?: string;
  id?: number;
  storageName: string;
  authorizedAdvertiserIds: number[];
}

type RemoteStorageRepositoryWithCredentials = StorageRepository & StorageRepositoryCredentials;

interface StorageRepositoryWithCredentials
  extends Omit<RemoteStorageRepositoryWithCredentials, 'accessToken' | 'secret' | 'credentials'> {
  credentialsKey: string;
  credentialsSecret: string;
  privateKey?: string;
  privateKeyPassphrase?: string;
}

export {
  StorageRepository,
  StorageType,
  StorageTypeName,
  StorageCredentials,
  S3AwsBucketCredentials,
  SFTPCredentials,
  AzureCredentials,
  GCPCredentials,
  RemoteStorageRepositoryWithCredentials,
  StorageRepositoryWithCredentials,
};
